import Vue from 'vue'
import Router from 'vue-router'
import TopPage from './components/TopPage.vue'
import ContentPage from './components/ContentPage.vue'
import ConfirmPage from './components/ConfirmPage.vue'
import ResultPage from './components/ResultPage.vue'
import InformationPage from './components/InformationPage.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        { path: '/result/:level', component: ResultPage, props: true },
        { path: '/', component: TopPage },
        { path: '/:lang', component: TopPage, props: true },
        { path: '/content/:level/:currentPage', component: ContentPage, props: true },
        { path: '/confirm/:level/', component: ConfirmPage, props: true },
        { path: '/links/:level/:q', component: InformationPage, props: true },
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
           return savedPosition
        } else {
           return { x: 0, y: 0 }
        }
    }
});